<template>
  <b-container>
    <b-row class="mt-5 pt-5">
      <b-col>
        <p class="">      Let's make life better in cities. Show your support for the National Park Cities movement by signing the first Universal Charter for National Park Cities below.
        </p>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col>
        <div class="charter__outer aster-background">
          <div class="charter__inner body-background">
            <b-row>
              <b-col>
                <h1 class="pb-3 text-center reallybig">Universal Charter for National Park Cities</h1>
                <div class="d-none d-lg-inline-block mb-4 w-100">
                  <div class="d-flex justify-content-center">
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                  </div>
                </div>
                <div class="d-inline-block d-lg-none mb-4 w-100">
                  <div class="d-flex justify-content-center">
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-2 mt-lg-3">
              <b-col lg="3">
                <p class="font-weight-bold text-uppercase larger">Our vision is to make cities where people, places and nature are better connected.</p>
              </b-col>
              <b-col lg="9">
                <p class="larger">Let’s make National Park Cities that are rich with nature and where everyone benefits from exploring, playing and learning outdoors. Cities where we all enjoy high quality public and green spaces, where the air is clean to breathe and it’s a pleasure to swim in their waters. Together we can make cities greener, healthier, fairer and more harmonious places to live. Why not?</p>

                <p>A National Park City is a shared vision and journey for a better life. <span class="font-weight-bold">Everyone in a National Park City is able to benefit and contribute everyday.</span></p>

                <p>It is a large-scale and long-term vision that is achievable through many actions. Much is already happening but by working, learning, sharing and acting together, across communities and governments, we can achieve even more.</p>

              </b-col>
            </b-row>
            <b-row class="mt-2 mt-lg-3">
              <b-col lg="3">
                <b-img class="img-fluid mb-5 mb-lg-0" style="max-height: 150px;" src="/static/images/UCNPC_BLK.png"></b-img>
              </b-col>
              <b-col lg="9">
                <p class="font-weight-bold text-uppercase">We are working together for better:</p>
                <ul>
                  <li id="yellow" class="font-weight-bold text-uppercase">lives, health and wellbeing</li>
                  <li id="green" class="font-weight-bold text-uppercase">wildlife, trees and flowers</li>
                  <li id="olive" class="font-weight-bold text-uppercase">places, habitats, air, water, sea and land</li>
                  <li id="blue" class="font-weight-bold text-uppercase">time outdoors, culture, art, playing, walking, cycling & eating</li>
                  <li id="purple" class="font-weight-bold text-uppercase">locally grown food and responsible consumption</li>
                  <li id="red" class="font-weight-bold text-uppercase">decisions, sharing, learning and working together</li>
                  <li id="brown" class="font-weight-bold text-uppercase">relationships with nature and with each other</li>
                </ul>
              </b-col>
            </b-row>
            <b-row class="mt-2 mt-lg-3">
              <b-col lg="3">
              </b-col>
              <b-col lg="9">
                <p class="font-weight-bold text-uppercase largerx2">This Charter confirms that we collectively share the ambition, responsibility and power to deliver  these things and more.</p>
              </b-col>
            </b-row>
            <b-row class="mt-2 mt-lg-3">
              <b-col lg="3">
              </b-col>
              <b-col lg="9">
                <hr class="d-none d-lg-block border-dark" >
                <p class="font-weight-bold text-uppercase">What is a National Park City?</p>
                <p>It’s a place, a vision and a city-wide community that is acting together to make life better for people, wildlife and nature. A defining feature is the widespread commitment to act so people, culture and nature work together to provide a better foundation for life.</p>

                <p>It is a timely cultural choice, a commitment to a sense of place and way of life that sustains people and nature in cities and beyond.</p>
                <p>People and cities around the world can draw from the goals, principles and aspirations of this Universal Charter for National Park Cities. We hope that there will be a strong National Park City Family that works together to fulfil the aspirations of this Universal Charter.</p>

                <p>The National Park City Foundation will work with others to publish a regular State of the National Park Cities report to highlight actions and progress being made to support the National Park City vision internationally.</p>

              </b-col>
            </b-row>
            <b-row class="mt-2 mt-lg-3">
              <b-col lg="3">
              </b-col>
              <b-col lg="9">
                <p>By signing this document I/we show our support for the vision of National Park Cities and pledge to help make them a success. <a href="#personform">Sign below</a></p>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="3"></b-col>
              <b-col lg="9">
                <hr class="border-dark" >
                <p class="small"> <b-img class="whatif-aster" src="/static/images/aster_green_tiny.png"></b-img>   What if we restored nature wherever we can?  <b-img class="whatif-aster" src="/static/images/aster_green_tiny.png"></b-img>   What if everybody could lose themselves in nature without leaving the city? <b-img class="whatif-aster" src="/static/images/aster_green_tiny.png"></b-img>   What if we shared more knowledge, ideas, tools and experiences? <b-img class="whatif-aster" src="/static/images/aster_green_tiny.png"></b-img>   What if there were more beautiful sights, smells, sounds and colours in the city? <b-img class="whatif-aster" src="/static/images/aster_green_tiny.png"></b-img>   What if we thought more about those who will be living in the city seven generations from now? <b-img class="whatif-aster" src="/static/images/aster_green_tiny.png"></b-img>   What if there was more celebration and spontaneity? <b-img class="whatif-aster" src="/static/images/aster_green_tiny.png"></b-img>   What if we did more things to care for the people, places and nature we are interdependent with? <b-img class="whatif-aster" src="/static/images/aster_green_tiny.png"></b-img>   What if there was more space for reconciliation? <b-img class="whatif-aster" src="/static/images/aster_green_tiny.png"></b-img>   What if we had more balance and harmony within ourselves, our city and globe?</p>
              </b-col>
            </b-row>
            <b-row class="mt-4">
              <b-col>
                <div class="d-none d-lg-inline-block mb-4 w-100">
                  <div class="d-flex justify-content-center">
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                  </div>
                </div>
                <div class="d-inline-block d-lg-none mb-4 w-100">
                  <div class="d-flex justify-content-center">
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                    <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row id="personform">
      <b-col>
        <PersonFormInternational v-model="$store.person"
                                 title="By signing this document I/we show our support for the vision of National Park Cities and pledge to help make them a success."
                                 :showOrganisationFields="true"
                                 :buttonLabel="'Sign the Charter'"
                                 @input="saveToServer"/>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col>
        <div class="text-center w-100">
          <b-img class="img-fluid" src="/static/images/universal_signing.jpg"></b-img>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-4 pb-5 mb-5">
      <b-col>
        <Signatures></Signatures>
      </b-col>
    </b-row>
    <b-row class="mt-2 pb-5 mb-5">
      <b-col>
        <a href="https://www.nationalparkcity.org" target="_blank">www.nationalparkcity.org</a> | <a href="https://www.twitter.com/NatParkCityFdn" target="_blank">@NatParkCityFdn</a> | <a href="https://www.nationalparkcity.org/privacy" target="_blank">Privacy policy</a>
      </b-col>
      <b-col>
        <div class="text-left highlight-bar social">
          <p>Please spread the word to your friends using #NationalParkCity</p>
          <div class="social__buttons">
            <SocialShare :showHeading="false"></SocialShare>
          </div>
        </div>
      </b-col>
    </b-row>

  </b-container>
</template>

<script>
import config from '../lib/config';
import surveys from '../lib/surveys';
import people from '../lib/people';
import SocialShare from '../components/widgets/SocialShare';
import PersonFormInternational from '../components/widgets/PersonFormInternational';
import myfunc from '../lib/myfunc';
import Signatures from './widgets/Signatures'
import AsterRow from './widgets/AsterRow'

export default {
  name: 'npc-universal-charter',
  data () {
    return {
      formSubmissionTried: false,
      savingToServer: false,
      msg: 'Welcome to Your Vue.js App',
      questionsInitialised: false,
      answersPressed: {}, // keyed off Question GUID for BOOLEAN Qs
      answersString: {}, // keyed off Question GUID for TEXT Qs
      questions: [],
    }
  },
  components: {
    AsterRow,
    Signatures,
    PersonFormInternational,
    SocialShare,
  },
  created () {
    //    var that = this;

    // NOT USING THIS -- JUST EXISTENCE OF PERSON DEFINES THAT THEY HAVE SIGNED
    //     // Load questions
    //     surveys.get(config.SURVEY_GUID)
    //       .then(survey => {
    //         // split the questions over categories to create an object of categories each containing an array of questions
    //         // the questions have their category in EXTRAS field
    //         // { challengeKey1 : {title: challenge1, things: [ {}, ... ] }, challengeKEy2: {}, ... }
    //         // Currently there is only one category being returned but this works if more were returned
    //         survey.questions.map(v => {
    //           // v = Survey Question. Guid is unique for each question
    //
    //           // Initialise the models which will hold the answers
    //           if (v.type === 'BOOLEAN') {
    //             // Will be a button
    //             // Need a single unique key for the synced pressed button tracking. Cannot use expression in the vue in HTML on :pressed.sync="<no expresssions just direct attr ref>"
    //             // For .sync to work the attr referenced must be properly reactive, which for dynamically set vars means have to use the .$set method
    //             // Without this setting the var was not triggering an event and the button was not changing state
    //             // that.answersPressed[v.guid] = false;
    //             that.$set(that.answersPressed, v.guid, false);
    //           } else if (v.type === 'STRING') {
    //             that.$set(that.answersString, v.guid, '');
    //           }
    //
    //           that.questions.push(v);
    //         })
    //         that.questionsInitialised = true;
    //       });
  },
  methods: {
    saveToServer: function () {
      var that = this;
      this.formSubmissionTried = true;

      this.savingToServer = true;

      // Create a person object - using the VueJS object directly (reference) may have been cause of some issues with Axios getting confused over the type of the embedded extra json
      var personToCreate = {
        email: this.$store.person.email,
        name: this.$store.person.name,

        extras: {
          permissionNewsletter: this.$store.person.extras.permissionNewsletter,
          country: this.$store.person.extras.country, // added to answers as well as person
          organisationName: this.$store.person.extras.organisationName, // added to answers as well as person
          comment: this.$store.person.extras.comment, // added to answers as well as person
          emailCopy: this.$store.person.email, // the other email is not stored in FMP, so for now add full email rather than in MLB obscured email since not adding to MailChimp currently
        }
      };

      // console.log('saveToServer()');
      people.post(personToCreate)
        .then(response => {
          var personGuid = response.guid;
          // Store the person in the state store
          that.$store.person.guid = personGuid;

          // console.log('Successfully posted');
          // console.log('Created person', personGuid);

          // Now add a survey answer indicating that they signed
          // Do this since need a way which we can use to get back at the data again
          // The data is in both the person and in the survey answer at the moment.
          // NOTE answers cannot be stored as NULL so only set if have a value!
          let answers = [];
          if (this.$store.person.extras.comment) {
            answers.push(
              {
                question: 'e44f562b-8036-4924-9747-77a0ec13eab5',
                answer: this.$store.person.extras.comment,
                extras: {}
              });
          }
          if (this.$store.person.extras.country) {
            answers.push(
              {
                question: '50081e4e-dc6b-4ac4-83c3-7e3d80e5daa8',
                answer: this.$store.person.extras.country,
                extras: {}
              });
          }
          if (this.$store.person.extras.organisationName) {
            answers.push(
              {
                question: 'fdcb8589-0240-44ed-993c-c096cc11a7ad',
                answer: this.$store.person.extras.organisationName,
                extras: {}
              });
          }
          if (this.$store.person.name || this.$store.person.extras.country || this.$store.person.extras.comment) {
            answers.push(
              { // overload this so can access the info we want to display in one field.
                question: 'b96ceba5-4fd6-4f09-854e-50665ad7ea9f',
                answer: `${this.$store.person.name}\\${this.$store.person.extras.country}\\${this.$store.person.extras.comment}`,
                extras: {}
              });
          }

          // console.log('submitting', answers);

          // Will always return with 200 even if some of the individual writes fail
          surveys.postBulkAnswers(config.SURVEY_GUID, personGuid, answers)
            .then(response => {
              that.savingToServer = false;

              // If any errors in the array of answers responses
              if (response.filter(r => {
                return (r.success !== true);
              }).length > 0) {
                console.error('Error in saving at least one of the answers');
                that.openModal('error');
              } else {
                // console.log('ALL ANSWERS SUCCESSFULLY POSTED');
                // Pass in what just signed so can feature at the top
                that.$router.push({
                  name: 'thanks',
                  params: {
                    signedName: that.$store.person.name,
                    signedCountry: that.$store.person.extras.country,
                    signedComment: that.$store.person.extras.comment,
                  }
                });
                that.resetForm();
              }
            });
        })
        .catch(err => {
          // person error
          console.error(err);
          that.$toasted.error('Sorry there has been a problem. Please try again later or let us know at hello@nationalparkcity.org quoting "uc2"');
        });
    },
    obscuredEmail () {
      return myfunc.obscuredEmail(this.$store.person.email);
    },
    resetForm () {
      this.formSubmissionTried = false;

      // TODO: perhaps this should be in the person form!
      // Leave the person set since may be used in subsequent screens
      this.$store.person = {
        email: null,
        name: null,
        extras: {
          permissionNewsletter: false,
          organisationName: null, // added to answers as well as person,
          comment: null, // added to answers as well as person,
          country: null, // added to answers as well as person,
        },
      };
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../scss/custom-bootstrap.scss';
@import '~bootstrap/scss/bootstrap.scss';

h1, h2 {
  font-weight: 800;
}
ul {
  list-style-type: none;
  padding: 0px;
}
li {
  margin: 0 10px;
  line-height: 2.5em;
}
li:before {
  content:'';
  display:inline-block;
  height:2em;
  width:2em;
  background-size:contain;
  background-repeat:no-repeat;
  padding: 0 2em 0 1em;
  vertical-align: -25%;
}
li#yellow:before {
  background-image:url('/static//images/aster_yellow.png');
}
li#green:before {
  background-image:url('/static//images/aster_green.png');
}
li#purple:before {
  background-image:url('/static//images/aster_purple.png');
}
li#blue:before {
  background-image:url('/static//images/aster_blue.png');
}
li#olive:before {
  background-image:url('/static//images/aster_olive.png');
}
li#red:before {
  background-image:url('/static//images/aster_red.png');
}
li#brown:before {
  background-image:url('/static//images/aster_brown.png');
}
a {
  color: #42b983;
}

.charter__outer {
  /*padding: 0.8em;*/
  /*padding: 2em 0.5em 1em 0.5em;*/
  margin: 2em 0;
  border-radius: 6px;
  border-color: $NPCGreen;

  > h3, > h5 {
    color: white;
    margin-top: 0;
    padding-left: 0.7em;
    padding-bottom: 0;
  }

}

.charter__inner {
  background-color: white;
  margin-top: 1em;
  padding: 2em;
  border: solid $NPCGreen 1px;
  border-radius: 6px;
}

// put behind the body background to tone it down?
.aster-background {
  background-image: url('/static/images/striped_aster.png');
  background-repeat: no-repeat;
  background-position: -50% 30%; /* 70% across and 20% down */
  z-index: 1;
}
.body-background {
  background-color: rgba(255,255,255,0.2);
  z-index: 2;
}

.medium {
  font-size: 0.9rem;
}
.larger {
  font-size: 1.2rem;
}
.largerx2 {
  font-size: 1.4rem;
}
.reallybig {
  @include media-breakpoint-up(lg) {
    font-size: 4rem;
  }
  font-size: 2.8rem;
}
.whatif-aster {
  width: 16px;
}
.title-aster {
  width: 12px;
}

</style>



// WEBPACK FOOTER //
// src/components/UniversalCharter.vue